export default __webpack_public_path__ + "static/media/benefits_3.4959752c.png";